/**
 * 已废弃的线性启发值等级阈值，仅供历史审计脚本复现旧方向。
 *
 * heuristicScore >= 大吉                    → 大吉
 * 大吉 > heuristicScore >= 吉               → 吉
 * 吉 > heuristicScore >= 平                 → 平
 * 平 > heuristicScore >= 不利               → 不利
 * heuristicScore < 不利                     → 大凶
 *
 * verdict() 不调用此分档，也始终返回 level:null；不得据此恢复机器吉凶结论。
 *
 * 多用神两现时不取平均，只选一个主爻：临世优先，其次动爻优先，其次按
 * 旺 > 相 > 休 > 囚 > 死，再取不空不破者；全部相同时取爻位较低者。
 * heuristicScore 使用主爻 score，其他同类爻只作辅爻陈述。
 */
export const VERDICT_THRESHOLDS = Object.freeze({
  大吉: 4,
  吉: 1.5,
  平: -1.5,
  不利: -4
});

/**
 * 应期候选的时间尺度分界。[待定]
 * 这里只给纯日期候选贴 day/month/year 标签；正式规格可能调整边界。
 */
export const TIME_SCALE_THRESHOLDS = Object.freeze({
  dayMax: 30,
  monthMax: 365
});

/**
 * 应期候选置信度参数。[用户规格，待古籍卦例回测]
 *
 * 这些数值是可辩护的工程刻度，并非野鹤原书给出的概率，也不是唯一正确
 * 的权重。置信度只描述“规则对这个日期的支持强弱”，不表示事情发生概率。
 */
export const TIMING_CONFIDENCE = Object.freeze({
  ruleStrength: Object.freeze({
    direct: 1.0,
    derived: 0.7,
    inferred: 0.4
  }),
  repeatBonus: Object.freeze({
    increment: 0.25,
    max: 1.5
  }),
  clarityFactor: Object.freeze({
    single: 1.0,
    two: 0.75,
    threePlus: 0.5
  })
});

export function verdictLevel(heuristicScore) {
  if (heuristicScore >= VERDICT_THRESHOLDS.大吉) return '大吉';
  if (heuristicScore >= VERDICT_THRESHOLDS.吉) return '吉';
  if (heuristicScore >= VERDICT_THRESHOLDS.平) return '平';
  if (heuristicScore >= VERDICT_THRESHOLDS.不利) return '不利';
  return '大凶';
}
